import { Static, String } from "runtypes";
import { EmptyObject, ValueOf } from "type-fest";

import { ContextWorkbenchEntity } from "./contextWorkbenchEntity";
import { ContextWorkbenchFileId } from "./contextWorkbenchFile";

type AnyObject = Record<string, unknown>;

export type ContextWorkbenchEditorFilesListNode =
  | ContextWorkbenchEditorFilesListNode.File
  | ContextWorkbenchEditorFilesListNode.AsyncPlaceholder;

export const ContextWorkbenchEditorFilesListNodeId = String.withBrand(
  "ContextWorkbenchEditorFilesListNodeId",
);
export type ContextWorkbenchEditorFilesListNodeId = Static<
  typeof ContextWorkbenchEditorFilesListNodeId
>;

/**
 * A node in the context workbench editor file tree.
 *
 * Named "editor files list" not "file list" because it pertains to the editor
 * view and can contain more than just file nodes, like their async states.
 * Thus, it's an expression of the "files list" and not just a "list of files".
 */
export namespace ContextWorkbenchEditorFilesListNode {
  export const Type = {
    File: "FileNode",
    AsyncPlaceholder: "AsyncPlaceholderNode",
  } as const;

  export type Type = ValueOf<typeof Type>;

  type _Base<
    TType extends ContextWorkbenchEditorFilesListNode.Type,
    TProperties extends AnyObject = EmptyObject,
  > = {
    id: ContextWorkbenchEditorFilesListNodeId;
    type: TType;
  } & TProperties;

  export type File = _Base<
    "FileNode",
    {
      fileId: ContextWorkbenchFileId;
    }
  >;

  export type AsyncPlaceholder = _Base<
    "AsyncPlaceholderNode",
    {
      entityType: ContextWorkbenchEntity.Type;
      loading: boolean;
      error: Error | undefined;
    }
  >;
}
